var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.7.003L7.01.45a.718.718 0 01.455.208l8.24 8.241c.4.4.4 1.056 0 1.456l-5.346 5.347c-.4.4-1.056.4-1.455 0L.662 7.46a.718.718 0 01-.208-.455L.009.77C-.035.424.294-.023.7.003zm3.59 3.2a1.061 1.061 0 00-.769.312 1.06 1.06 0 000 1.506c.42.42 1.085.419 1.504 0a1.06 1.06 0 000-1.506 1.055 1.055 0 00-.736-.312z",
    fillRule: "evenodd"
  })));
}

export default SvgLabel;